module.exports = __webpack_public_path__ + "static/everybody-matters-870df08cf473b443874ba93111c364ee.jpg";